import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceEventView } from 'src/app/data/model/device-event-view';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { DeviceEventViewApiService } from '../../../shared/api/services/events-api.service';
import {Icon, DomEvent, Map, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker } from 'leaflet';
import { FormBuilder } from '@angular/forms';
import { getCombinedModifierFlags } from 'typescript';
import { timestamp } from 'rxjs';
import { DatePipe, DATE_PIPE_DEFAULT_TIMEZONE, registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-dialog-img',
    templateUrl: './dialog-img.component.html',
    styleUrls: ['./dialog-img.component.scss'],
})
export class DialogImgComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
      ) { }
    
      get_img(img:string){
        if(img !== null){
          return img//+'?height=600&width=900'
        }
        return img
      }
}

export type DialogMapParams = {
  data: any;
};
